import { Title } from './Title';
import { Text } from './Text';
import { Paragraph } from './Paragraph';
import LinkText from './LinkText';
export var Typography = {
  Title: Title,
  Text: Text,
  Paragraph: Paragraph,
  LinkText: LinkText
};
//# sourceMappingURL=index.js.map